import { CardContent, styled } from "@mui/material";

export default styled(CardContent)(`
  padding: 0;
  &:last-child {
    padding-bottom: 0;
  }
`);
